import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsReact from "highcharts-react-official";

Highcharts3D(Highcharts);

// helper: turn "YYYY-MM-DD" into a UTC‑midnight timestamp
const parseUTCDate = (ymd) => {
  const [year, month, day] = ymd.split("-").map(Number);
  // Date.UTC builds ms since epoch at UTC midnight of that date
  return Date.UTC(year, month - 1, day);
};

const CandleChart = ({ candleData }) => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "column",
      height: 400,
      options3d: { enabled: false },
    },
    title: {
      text: '<h4>Document Uploads vs. MORi Manual Outputs vs. MORi Automated Outputs</h4>',
      align: "left",
      useHTML: true,
      style: {
        color: "#1565c3",
        fontFamily: "Arial",
        fontWeight: "Semibold",
      },
      margin: 20,
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: {
      title: { text: "Number of Files" },
    },
    plotOptions: {
      column: {
        pointWidth: 20,
        borderWidth: 2,
        dataLabels: {
          enabled: true,
          formatter: function () {
            return this.y;
          },
          align: "center",
          verticalAlign: "top",
          style: {
            color: "#000000",
            fontSize: "10px",
          },
        },
      },
    },
    series: [
      { name: "Uploads", color: "#8dc640", data: [] },
      { name: "Manual Outputs", color: "#0000FF", data: [] },
      { name: "Automated Outputs", color: "#FFA500", data: [] },
    ],
    credits: { enabled: false },
    tooltip: {
      enabled: true,
      formatter: function () {
        return `<b>${this.series.name}</b><br/>${Highcharts.dateFormat(
          "%A, %b %e, %Y",
          this.x
        )}`;
      },
    },
  });

  useEffect(() => {
    if (
      !candleData ||
      !candleData.resultForFileUploadedPerDay ||
      !candleData.resultForManualProcessCurrentWeek ||
      !candleData.resultForAutoProcessCurrentWeek
    ) {
      return;
    }

    const uploadsArr = candleData.resultForFileUploadedPerDay;
    const manualArr = candleData.resultForManualProcessCurrentWeek;
    const autoArr = candleData.resultForAutoProcessCurrentWeek;

    // build one flat array of {x, close, name}
    const allPoints = [];
    uploadsArr.forEach((d, i) =>
      allPoints.push({ x: parseUTCDate(d.date), close: d.count, name: "Uploads" })
    );
    manualArr.forEach((d, i) =>
      allPoints.push({ x: parseUTCDate(d.date), close: d.count, name: "Manual Outputs" })
    );
    autoArr.forEach((d, i) =>
      allPoints.push({ x: parseUTCDate(d.date), close: d.count, name: "Automated Outputs" })
    );

    const buildSeries = (seriesName, color) => {
      const pts = allPoints
        .filter((p) => p.name === seriesName)
        .map((p) => [p.x, p.close]);
      const total = pts.reduce((sum, [, v]) => sum + v, 0);
      return {
        name: `${seriesName} (${total})`,
        color,
        data: pts,
      };
    };

    setChartOptions((prev) => ({
      ...prev,
      series: [
        buildSeries("Uploads", "#8dc640"),
        buildSeries("Manual Outputs", "#0000FF"),
        buildSeries("Automated Outputs", "#FFA500"),
      ],
    }));
  }, [candleData]);

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default CandleChart;
